<template>
  <v-app-bar app color="primary" dark>
    <div class="d-flex align-center">
      <h2>Diniz Finanças</h2>
    </div>

    <v-spacer></v-spacer>

    <v-btn text to="admin" v-if="usuario.is_staff"> Adminstração </v-btn>
    <v-btn text to="financas"> Finanças </v-btn>
    <v-btn text to="lembretes"> Lembretes </v-btn>

    <v-spacer></v-spacer>

    <div class="d-flex align-center">
      <PerfilView :usuario="usuario" />
    </div>
  </v-app-bar>
</template>

<script>
import PerfilView from "@/views/perfil/PerfilView";
import api from '@/services/api'
import verifica_token_storage from "@/utils/verifica_token_storage";
import { mapMutations } from 'vuex';

export default {
  name: "HeaderComp",

  components: {
    PerfilView,
  },

  data: () => ({
    usuario: {},
  }),

  created() {
    this.get_usuario();
  },

  methods: {
    ...mapMutations(["CarregandoMutation"]),

    get_usuario() {
      this.CarregandoMutation();
      const headers = verifica_token_storage();

      api
        .get("perfil/", { headers })
        .then((response) => {
          this.usuario = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.CarregandoMutation();
        });
    },
  },
};
</script>
